module.exports = __webpack_public_path__ + "img/Icon=Android.2afb19fa.svg";